// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bgalphacolor {
    background-color: rgb(255 255 255 / 70%);
}`, "",{"version":3,"sources":["webpack://./src/SidebarComponent/AboutUs.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C","sourcesContent":[".bgalphacolor {\r\n    background-color: rgb(255 255 255 / 70%);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
